<template>

</template>

<script>
    import {AUser} from "~/store/actions";
    import {mapGetters} from "vuex";
    import {GCommon} from "@/store/getters";

    export default {
        name: "ActivateGift",
        head: {
            title: 'Activate gift | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
        },
        computed: {
            ...mapGetters({
                mobileCheck: GCommon.GET_MOBILE_VERSION
            })
        },
        mounted() {
            if (this.mobileCheck) {
                window.location.href = 'vindome://gift'
            } else {
                this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
                    this.$router.push(this.localePath({path: '/my-account'}));
                }).catch((err) => {
                    this.$router.push(this.localePath({path: '/login'}));
                });
            }
        }
    }
</script>

<style scoped>

</style>
